export default "__VITE_ASSET__nj_wO4FE__"